class BESSAppModal extends BESSAppBase {

    constructor(modalIdentifier) {
        super();
        this.identifier = modalIdentifier;
        this.onShownFn = null;

        const node = $('#' + modalIdentifier);
        node.find('.modal-dialog').addClass('app-modal-dialog');
        this.view = {
            node: node,
            title: node.find('.app-modal-title'),
            body: node.find('.modal-body'),
            message: node.find('.app-modal-message'),
        };
        let modalSelector = '#' + modalIdentifier;
        this.modal = new bootstrap.Modal(modalSelector, {
            backdrop: 'static',
            keyboard: false,
        });

        $(modalSelector).off('shown.bs.modal').on('shown.bs.modal', this.onShown.bind(this))
    }

    open(onShownFn = null) {
        this.onShownFn = onShownFn;
        this.log("opening: " + this.identifier);
        this.modalOpening = true;
        this.modal.show();
    }

    close() {
        if(this.modalOpening) {
            this.doDelayed(this.close, 500);
        } else {
            this.log("closing: " + this.identifier);
            this.modal.hide();
        }
    }

    setTitle(title) {
        this.view.title.html(title);
    }

    setMessage(message) {
        this.view.message.html(message);
    }

    onShown() {
        if (this.onShownFn !== null) {
            this.onShownFn();
        }
        this.modalOpening = false;
        this.log("shown: " + this.identifier);
    }
}